import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  dismissSuggestion: {
    id: 'fabric.editor.ai.spellingAndGrammar.suggestions.dismiss',
    defaultMessage: 'Dismiss Suggestion',
    description: 'The tooltip message display for the dismiss icon button in the suggestion toolbar'
  }
});